import AdminLogin from '@/components/admin/Login.vue'
import AssignQuestionMagement from '@/components/dashboard/question/AssignQuestionMagement.vue'
import UserPerfil from '@/components/ui/UserResponsesQuesiton.vue'
import { getEnterprises } from '@/services/company/api.enterprise'
import AdminDashboard from '@/views/admin/AdminDashboard.vue'
import CompanyPage from '@/views/page/CompanyPage.vue'
import HomeComponent from '@/views/page/HomeComponent.vue'
import { createRouter, createWebHistory } from 'vue-router'
const routes = [
  {
    path: '/question',
    name: 'Question',
    component: AssignQuestionMagement,
  },

  {
    path: '/userperfil',
    name: 'UserPerfil',
    component: UserPerfil,
  },

  {
    path: '/',
    name: 'Home',
    component: HomeComponent,
  },
  {
    path: '/admin',
    name: 'AdminLogin',
    component: AdminLogin,
  },
  {
    path: '/admin/dashboard',
    name: 'AdminDashboard',
    component: AdminDashboard,
  },
  {
    path: '/:companyName',
    name: 'Company',
    component: CompanyPage,
    props: true,
    beforeEnter: async (to, from, next) => {
      try {
        const enterprises = await getEnterprises()
        const company = enterprises.find(
          (e) =>
            e.NomeEmpresa.toLowerCase() === to.params.companyName.toLowerCase()
        )

        if (company) {
          to.params.company = company
          next()
        } else {
          next({ name: 'Home' })
        }
      } catch (error) {
        console.error('Erro ao buscar empresas:', error)
        next({ name: 'Home' })
      }
    },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
